import type { ArithKey } from './keys';

export const nl: Partial<Record<ArithKey, string>> = {
  'app.title': 'Rekenen',
  'app.eyebrow': 'Wiskunde · Rekenen',
  'app.tagline': 'Visueel rekenen voor het hele middelbareschoolprogramma',
  'app.panel.heading': 'Parameters',
  'panel.enter-number': 'Voer een getal in',
  'formula.is-prime': 'is priem',
  'experiment.fraction-foundry.label': 'Breukenfabriek',
  'experiment.percent-grid.label': 'Procentenraster',
  'experiment.prime-factor-tree.label': 'Priemfactorboom',
  'experiment.modular-clock.label': 'Modulaire klok',
  'experiment.number-line-surgeon.label': 'Getallenlijn-chirurg',
  'experiment.place-value-blocks.label': 'MAB-blokken',
  'experiment.ratio-mixer.label': 'Verhoudingsmixer',
  'experiment.power-tower.label': 'Machtstoren',
  'op.add': 'plus',
  'op.sub': 'min',
  'op.mul': 'keer',
  'op.div': 'gedeeld door',
  'btn.reset': 'Herstel',
  'btn.randomise': 'Willekeurig',
  'btn.advanced': 'Geavanceerd',
  'class.perfect': 'volmaakt getal',
  'class.abundant': 'abundant getal',
  'class.deficient': 'deficiënt getal',
  'mode.basic': 'Basis',
  'mode.inverse': 'Inverse',
};
